<template>
  <div class="user_info_form">
    <h4>사업자 정보​</h4>
    <p v-if="userInfo.businessType == 2" class="description">
      개인사업자의 경우 대표자가 계정 신상과 동일한 경우만 가능합니다. ​
    </p>
    <p v-else class="description">사업자 정보를 입력해주세요​.</p>
    <dl>
      <dt>업체(법인)명</dt>
      <dd>{{ userInfo.businessName }}​</dd>
    </dl>
    <dl>
      <dt>사업자등록번호</dt>
      <dd>{{ userInfo.businessLicenseNumber }}​</dd>
    </dl>
    <dl class="userName">
      <dt>대표자명​</dt>
      <dd v-if="userInfo.businessType == 2">{{ userInfo.businessOwnerName }}</dd>
      <dd v-if="userInfo.businessType == 3" class="form">
        <v-input v-model="businessOwnerName" @custom-input="updateBusinessInfo" />
      </dd>
    </dl>
    <address-form @update="updateAddress"></address-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VInput from '@/components/atoms/VInput';
import AddressForm from '@/components/modules/common/AddressForm';

export default {
  components: {
    VInput,
    AddressForm,
  },
  data() {
    return {
      businessOwnerName: '',
      address: {},
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
  },
  methods: {
    updateBusinessInfo() {
      this.$emit('update', {
        request: { ...this.address.request, businessOwnerName: this.businessOwnerName },
        isState: this.address.isState && (this.userInfo.businessType == 3 ? !!this.businessOwnerName : true),
      });
    },
    updateAddress(val) {
      this.address = val;
      this.updateBusinessInfo();
    },
  },
};
</script>
<style lang="scss"></style>
